module.exports = __webpack_public_path__ + "img/bakery_bodyimage03.c36a3a5e.jpg";